import { Wallet } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useLanguage } from "@/context/LanguageContext";

const LOGOS = { wave: "/payments/wave.jpg", mtn: "/payments/mtn.jpg", orange: "/payments/orange.jpg" };

export const PaymentMethods = ({ compact = false, testid = "payment-methods" }) => {
  const { settings } = useSettings();
  const { t } = useLanguage();
  const p = settings.payments || {};
  const methods = (p.methods || []).filter((m) => m.enabled !== false && m.number);
  if (settings.sections?.payments === false || methods.length === 0) return null;

  if (compact) {
    return (
      <div data-testid={testid}>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/60">{t.payments.title}</p>
        <ul className="mt-3 space-y-2.5 text-sm">
          {methods.map((m) => (
            <li key={m.id} className="flex items-center gap-3" data-testid={`${testid}-${m.id}`}>
              {LOGOS[m.id] ? <img src={LOGOS[m.id]} alt={m.label} className="h-8 w-12 shrink-0 rounded-md object-cover" loading="lazy" /> : <span className="flex h-8 w-12 shrink-0 items-center justify-center rounded-md bg-white/10"><Wallet className="h-4 w-4 text-gold" /></span>}
              <span className="min-w-0 leading-tight">
                <span className="block truncate text-[11px] uppercase tracking-wider text-white/60">{m.label}</span>
                <a href={`tel:${m.number.replace(/\s/g, "")}`} className="block whitespace-nowrap font-semibold text-white transition-colors hover:text-gold">{m.number}</a>
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <section className="rounded-3xl border border-brand/10 bg-white p-6 sm:p-8" data-testid={testid}>
      <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-brand"><Wallet className="h-4 w-4 text-gold" /> {t.payments.title}</p>
      {p.note && <p className="mt-3 text-sm leading-relaxed text-forest">{p.note}</p>}
      <div className="mt-5 grid gap-3 sm:grid-cols-3">
        {methods.map((m) => (
          <div key={m.id} className="flex items-center gap-3 rounded-2xl bg-cream p-4 transition-transform hover:-translate-y-0.5" data-testid={`${testid}-${m.id}`}>
            {LOGOS[m.id] ? <img src={LOGOS[m.id]} alt={m.label} className="h-12 w-20 shrink-0 rounded-xl object-cover" loading="lazy" /> : <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white text-gold"><Wallet className="h-5 w-5" /></span>}
            <div className="min-w-0">
              <p className="text-xs font-semibold text-brand">{m.label}</p>
              <a href={`tel:${m.number.replace(/\s/g, "")}`} className="block font-display text-base font-bold text-forest hover:text-gold">{m.number}</a>
            </div>
          </div>
        ))}
      </div>
      {p.holder && <p className="mt-4 text-xs text-brand-hover">{t.payments.holder} : <b className="text-forest">{p.holder}</b></p>}
    </section>
  );
};

export default PaymentMethods;
